import React from 'react';
import { connect } from 'react-redux';
import { triggerHistoriskeLokalplaner } from '../../../store/actions';
import { useSpring, animated } from 'react-spring';
import styled, { css, keyframes } from 'styled-components';
import { size } from '../../../style/util';
import { Times } from '../../common/Icons/Light';
import { Share } from '../../common/Icons/Regular';
import { ILokalplan } from '../../../Interfaces/ILokalplan';
import { common } from '../../../style';
import { neutral, pink, orange } from '../../../style/colors';
import { useMedia } from '../../../hooks/useMedia';
import { PositionProperty } from 'csstype';
import SidebarButton from '../../common/Buttons/SidebarButton';
import LokalplanList from '../Lokalplan/LokalplanList';
import LokalplanInfo from './HistoriskLokalplanInfo';

const HistorikSidebar = (props: IHistorikSidebarPropType) => {
  const {
    lokalplan,
    onClose,
    hoveredPlans,
    onListItemClick,
    onListItemHover,
    toggled,
    loading,
    setTriggerHistorik,
  } = props;
  const isSmallScreen = useMedia(
    [`(max-width: ${size.small}px)`],
    [true],
    false
  );
  const navAnimation = useSpring({
    config: { duration: 300 },
    right: !isSmallScreen ? (toggled ? '0px' : '-430px') : '0px',
    bottom: isSmallScreen ? (toggled ? '0vh' : '-40vh') : '0vh',
  });
  const baseStyle = {
    position: 'fixed' as PositionProperty,
    bottom: 0,
    left: 0,
    backgroundColor:
      loading || !lokalplan || !lokalplan.feature.properties.aktuel
        ? '#F7F4EE'
        : common.backgroundColor,
    height: '40vh',
    zIndex: 4,
    boxShadow: common.boxShadow,
  };
  const style = isSmallScreen
    ? { ...baseStyle }
    : { ...baseStyle, left: 'unset', height: '100%', width: '430px' };

  if (!lokalplan || loading) {
    return (
      <animated.div style={{ ...style, ...navAnimation }}>
        <HeaderRow aktuel={false} pulse={true}>
          <h2>&nbsp;</h2>
          <h1>&nbsp;</h1>
          <h3>&nbsp;</h3>
        </HeaderRow>
      </animated.div>
    );
  }
  const { feature = undefined, delomraader = [], byggefelter = [] } =
    lokalplan || {};
  const { properties = undefined } = feature || {};
  const { doklink = undefined } = properties || {};
  const buttonIcon = <Share color="#FFFFFF" width={16} />;

  return (
    <animated.div style={{ ...style, ...navAnimation }}>
      <div
        onClick={() => {
          onClose();
          setTriggerHistorik(false);
        }}
        style={{
          position: 'absolute',
          top: 16,
          right: 16,
          cursor: 'pointer',
          backgroundColor: '#627d98',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: 32,
          width: 32,
          borderRadius: '50%',
        }}
      >
        <Times color={'#F7F4EE'} width={16} height={16} />
      </div>
      <ScrollWrapper>
        <div>
          <HeaderRow aktuel={lokalplan.feature.properties.aktuel}>
            <h2>{lokalplan.feature.properties.plannr}</h2>
            <h1>{lokalplan.feature.properties.plannavn}</h1>
            <h3>
              <span style={{ color: '#9AA2A7' }}>PlanId:</span>{' '}
              {lokalplan.feature.properties.planid}{' '}
              <span style={{ marginLeft: 40, color: '#9AA2A7' }}>Version:</span>{' '}
              {lokalplan.feature.properties.versionsnr}
            </h3>
          </HeaderRow>
          <div style={{ paddingBottom: 20 }}>
            <LokalplanInfo properties={properties} />
            <SidebarButton
              onClick={doklink ? () => window.open(doklink) : () => {}}
              icon={buttonIcon}
              text={'ÅBN PLAN'}
            />

            <LokalplanList
              title="Delområder"
              accentColor={pink[600]}
              bgColor={'#FDF3F8'}
              planer={delomraader}
              onListItemClick={onListItemClick}
              onListItemHover={onListItemHover}
              hoveredPlans={hoveredPlans}
            />
            <LokalplanList
              title="Byggefelter"
              accentColor={orange[600]}
              bgColor={'#fdfcf3'}
              planer={byggefelter}
              onListItemClick={onListItemClick}
              onListItemHover={onListItemHover}
              hoveredPlans={hoveredPlans}
            />
          </div>
        </div>
      </ScrollWrapper>
    </animated.div>
  );
};

const ScrollWrapper = styled.div`
  overflow-y: auto;
  height: 100%;
`;
const pulse = keyframes`
  0% {
        background-color: #e6e2dc;
    }
    50% {
        background-color: #ede9e4;
    }
    100% {
        background-color: #e6e2dc;
    }
`;
const HeaderRow = styled.div`
  padding: 38px 32px 15px 32px;
  background-color: ${common.backgroundColor};
  ${props =>
    !props.aktuel &&
    css`
      background-color: #f7f4ee;
    `}
  border: 1px ${neutral[200]};
  box-shadow: 0 0 10px 0 rgba(72,60,36,0.15);
  border-style: solid none;
  h1 {
    margin: 10px 0;
    font-size: 20px;
    line-height: 140%;
  }
  h3 {
    margin: 0 0 10px 0;
  }
  h2 {
    margin: 0;
    font-size: 15px;
  }
  ${props =>
    props.pulse &&
    css`
      h2 {
        animation: ${pulse} 1s infinite ease-in-out;
        width: 60px;
      }
      h1 {
        animation: ${pulse} 1s infinite ease-in-out;
        width: 280px;
      }
      h3 {
        animation: ${pulse} 1s infinite ease-in-out;
        width: 40px;
      }
    `}
`;

interface IHistorikSidebarPropType {
  lokalplan: ILokalplan;
  onClose: Function;
  onListItemClick?: Function;
  onListItemHover?: Function;
  hoveredPlans: Array<number>;
  toggled: boolean;
  loading: boolean;
  setTriggerHistorik: Function;
}
const mapDispatchToProps = dispatch => {
  return {
    setTriggerHistorik: toggled => {
      dispatch(triggerHistoriskeLokalplaner(toggled));
    },
  };
};
export default connect(
  null,
  mapDispatchToProps
)(HistorikSidebar);
